/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { grey } from '@mui/material/colors';

export  function AddFilesModal({ open, onClose, files, setFiles }) {
  const [loadingForm, setLoadingForm] = useState(false);

  const handleOnCloseModal = () => {
    // setFiles([])
    onClose()
  }

  const handleChangeFile = async (events) => {
    let uploadFiles = [...files];
    for (const [key, value] of Object.entries(events)) {
        uploadFiles.push(value)
      }
      setFiles(uploadFiles)
    }
    
  const handleSubmit = async () => {
    setLoadingForm(true);
    if (files.length <= 0) {
      setLoadingForm(false);
      enqueueSnackbar('Selecione uma imagem para upload!', { variant: 'info' });
      return
    }

    try {
      enqueueSnackbar('Arquivo adicionado com sucesso!', { variant: 'success' });
      // CLEANUP AND CLOSE
      setLoadingForm(false);
      //setFiles([]);
      handleOnCloseModal();
      
    } catch (error) {
      setLoadingForm(false);
      enqueueSnackbar('Erro ao carregar Arquivo!', { variant: 'error' });
      return
    }
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Adicionar Arquivo
        </Typography>
      </Box>
      
      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>
        <label id="thumbnail">
          <Box>
            <Typography sx={{
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#fff',
              padding: '5px'
            }}>
              {files.length > 0 ? 'Adicionar outro arquivo' : 'Escolha o arquivo'}
            </Typography>
          </Box>

          <input
            type="file"
            multiple
            accept="application/image"
            onChange={event => handleChangeFile(event.target.files)}
          />
        </label>
        
        <Box>
          {files.map((file, index) => {
            return (
              <Typography key={index}>
                {file.name}
              </Typography>
            )
          })}
        </Box>

        <Box>
          {loadingForm ? (
            <Box sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}>
              <CircularProgress color='success' />
            </Box>
          ) : (
            <Box sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end',
              gap: 1
            }}>
              <Button
                color="error"
                variant='contained'
                onClick={handleOnCloseModal}
                >
                  Fechar
              </Button>
              <Button
                variant='contained'
                color="success"
                type="submit"
                onClick={() => { handleSubmit() }}
                >
                  Carregar
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
